//== validation rules for the FHS service charges calculator
//== pure function; returns { valid: boolean, errors: { [field]: string } }
//== error strings are placeholder English; route through config.copy when CMS
//== messages are added.
//==
//== the workbook applies no validation at all (plan doc §6, Q8), so these
//== rules are ours. scope agreed 2026-08-18: required / numeric on all three
//== fields, plus one hard block where the figures are arithmetically
//== impossible. no scheme maximum on the equity share - the client has not
//== given one, and inventing a cap would reject valid customers.

const isPositiveFinite = (n) => typeof n === 'number' && Number.isFinite(n) && n > 0
const isNonNegativeFinite = (n) => typeof n === 'number' && Number.isFinite(n) && n >= 0

const result = (errors) => ({ valid: Object.keys(errors).length === 0, errors })

export function validate(state) {
  const errors = {}
  const inputs = state?.inputs ?? {}

  if (!isPositiveFinite(inputs.purchasePrice)) {
    errors.purchasePrice = 'Please enter your purchase price or build cost'
  }

  if (!isPositiveFinite(inputs.originalEquity)) {
    errors.originalEquity = 'Please enter your original FHS equity'
  } else if (isPositiveFinite(inputs.purchasePrice) && inputs.originalEquity > inputs.purchasePrice) {
    //== hard block: this puts the original equity share above 100%, which
    //== cannot be right whatever the scheme rules turn out to be
    errors.originalEquity = 'Your original FHS equity cannot be more than your purchase price'
  }

  if (!isNonNegativeFinite(inputs.currentEquityPct)) {
    errors.currentEquityPct = 'Please enter your current FHS equity share percentage'
  } else if (inputs.currentEquityPct > 100) {
    //== not a scheme cap - a share of more than 100% is arithmetically
    //== impossible, so it is caught here rather than left to produce a figure
    errors.currentEquityPct = 'Your current FHS equity share percentage cannot be more than 100%'
  }

  return result(errors)
}
